import { render } from "./destroy-document-modal.vue?vue&type=template&id=bc0d5fa8"
import script from "./destroy-document-modal.vue?vue&type=script&lang=js"
export * from "./destroy-document-modal.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__